export default __webpack_public_path__ + "static/casablanca-cef930993b6fb7372352816f25db490c.png";